var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("menu", [
    _c("div", { staticClass: "tabbed-menu building mb-10 md:mb-12" }, [
      _c(
        "ul",
        {
          style: { marginLeft: _vm.navStyle },
          attrs: { "data-num-tabs": _vm.tabs.length, id: "submenu" }
        },
        _vm._l(_vm.tabs, function(tab) {
          return _c(
            "li",
            {
              key: tab.id,
              staticClass: "tab",
              class: { active: _vm.isActive(tab.url) }
            },
            [_c("a", { attrs: { href: tab.url } }, [_vm._v(_vm._s(tab.title))])]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.tabs.length > 5
      ? _c("div", { staticClass: "nav" }, [
          _c(
            "svg",
            {
              staticClass: "prevBtn",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 12 14"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.scrollNav("←")
                }
              }
            },
            [
              _c("defs"),
              _vm._v(" "),
              _c("path", {
                attrs: { fill: "#58554D", d: "M0 7L12 .072v13.856L0 7z" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "svg",
            {
              class: ["active" ? _vm.tabs.length > 5 : "", "nextBtn"],
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 12 14"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.scrollNav("→")
                }
              }
            },
            [
              _c("defs"),
              _vm._v(" "),
              _c("path", {
                attrs: { fill: "#97948B", d: "M12 7L0 13.928V.072L12 7z" }
              })
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }